import { render, staticRenderFns } from "./NeedsInfo.vue?vue&type=template&id=083316b6&scoped=true&"
import script from "./NeedsInfo.vue?vue&type=script&lang=js&"
export * from "./NeedsInfo.vue?vue&type=script&lang=js&"
import style0 from "./NeedsInfo.vue?vue&type=style&index=0&id=083316b6&lang=less&scoped=true&"
import style1 from "./NeedsInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083316b6",
  null
  
)

export default component.exports